import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Typography,
  IconButton,
  Tooltip
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import "./DatasetBuilder.scss"; // Ensure styles are available
import { VETSTAT_UI } from "../../strings";

interface ExportDialogProps {
  open: boolean;
  onClose: () => void;
  onExport: (
    format: "png" | "jpeg" | "pdf"
  ) => void;
}

const ExportDialog: React.FC<ExportDialogProps> = ({
  open,
  onClose,
  onExport,
}) => {
  const initialState = {
    format: "pdf" as "png" | "jpeg" | "pdf",
  };
  const [format, setFormat] = useState(initialState.format);

  const handleFormatChange = (event: SelectChangeEvent<"png" | "jpeg" | "pdf">) => {
    setFormat(event.target.value as "png" | "jpeg" | "pdf");
  };

  const handleExport = () => {
    onExport(format);
    onClose();
  };

  const handleReset = () => {
    setFormat(initialState.format);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{VETSTAT_UI.datasetBuilder.exportConfigurationTitle}</DialogTitle>
      <DialogContent dividers>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6" style={{ fontSize: '1rem', color: '#666' }}>{VETSTAT_UI.datasetBuilder.settings}</Typography>
          <Tooltip title={VETSTAT_UI.datasetBuilder.resetSettings}>
                    <IconButton size="small" onClick={handleReset}>
                        <RefreshIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            </div>

            <FormControl fullWidth size="small">
                <InputLabel id="export-format-label">Format</InputLabel>
                <Select
                labelId="export-format-label"
                value={format}
                label="Format"
                onChange={handleFormatChange}
                >
                <MenuItem value="pdf">PDF</MenuItem>
                <MenuItem value="png">PNG</MenuItem>
                <MenuItem value="jpeg">JPEG</MenuItem>
                </Select>
            </FormControl>
          </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {VETSTAT_UI.datasetBuilder.cancel}
        </Button>
        <Button onClick={handleExport} color="primary" variant="contained">
          Download {format.toUpperCase()}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportDialog;